<div class="slider-container">

  <div class="explanation">
    <p>Please select the minimum and maximum market capitalization range. You can use the slider or manually input values for more precision.</p>
  </div>

  <div class="slider-section">
    <ngx-slider
      [(value)]="sliderMin"
      [(highValue)]="sliderMax"
      [options]="sliderOptions"
      (userChangeEnd)="onSliderChange()">
    </ngx-slider>
  </div>


  <div class="input-section">
    <mat-form-field appearance="fill" class="input-field">
      <mat-label>Min Market Cap</mat-label>
      <input matInput [(ngModel)]="minCapInput" (ngModelChange)="parseMarketCapInputs()" [placeholder]="'500M'">
    </mat-form-field>

    <mat-form-field appearance="fill" class="input-field">
      <mat-label>Max Market Cap</mat-label>
      <input matInput [(ngModel)]="maxCapInput" (ngModelChange)="parseMarketCapInputs()" [placeholder]="'5T'">
    </mat-form-field>
  </div>


  <div class="button-section">
    <button mat-raised-button color="primary" (click)="onConfirm()">OK</button>
  </div>
</div>
